<script lang="ts">
  import Title from '$shared/atoms/Title/Title.svelte';
  import ConfirmActions from '$shared/atoms/ConfirmActions/ConfirmActions.svelte';

  interface Props {
    title?: string;
    okLabel?: string;
    cancelLabel?: string;
    hideCancel?: boolean;
    loading?: boolean;
    disabled?: boolean;
    desc?: string;
    subDesc?: string;
    children?: import('svelte').Snippet;
    onevent?: (detail: { type: string }) => void;
  }

  let {
    title = '',
    okLabel = '',
    cancelLabel = '',
    hideCancel = false,
    loading = false,
    disabled = false,
    desc = '',
    subDesc = '',
    children,
    onevent
  }: Props = $props();

  const handleOk = () => {
    onevent?.({ type: 'ok' });
  };

  const handleCancel = () => {
    onevent?.({ type: 'close' });
  };

  const handleWindowKeyUp = (e): void => {
    if (e.which == 13) {
      handleOk();
      return;
    }
  };
</script>

<svelte:window onkeyup={handleWindowKeyUp} />
<div data-cy="confirmation-popup" class="comp-confirm-popup">
  <div data-cy="title" class="title"><Title type="h3">{title}</Title></div>
  {#if desc}
    <div data-cy="description" class="desc">{desc}</div>
    {#if subDesc}
      <div class="sub-desc">{subDesc}</div>
    {/if}
  {/if}

  {@render children?.()}

  <div class="actions">
    <ConfirmActions
      {hideCancel}
      {loading}
      {disabled}
      {okLabel}
      {cancelLabel}
      onok={handleOk}
      oncancel={handleCancel}
    />
  </div>
</div>

<style>
  .comp-confirm-popup {
    padding: 24px;
    width: 400px;
  }
  .title {
    margin-bottom: 16px;
  }
  .desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
  .sub-desc {
    margin-top: 20px;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
  .actions {
    margin-top: 24px;
  }
</style>
